import { ServiceToolsClient } from "src/entities/serviceToolsClient/";

export const ServiceToolsClientPage = () => {
  return <ServiceToolsClient />;
};
